import DashboardHeaderContainer from './containers/DashboardHeaderContainer';

export default DashboardHeaderContainer;
